exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-style[data-v-20987e16] .search:first-letter,.select-style[data-v-20987e16] .ui.search.dropdown>.text:first-letter,.select-style[data-v-20987e16] .ui.selection.dropdown .menu>.item:first-letter{text-transform:capitalize}.select-style[data-v-20987e16] .ui.selection.dropdown .menu{font-family:artifaktElementRegular;max-height:150px}.select-style[data-v-20987e16] .ui.search.dropdown.active,.select-style[data-v-20987e16] .ui.search.dropdown>input.search{font-family:artifaktElementRegular}", ""]);

// exports
